<script setup lang="ts">
const props = defineProps<{
  totalBlock: any
  total?: number
}>()

const { t } = useLocale()
const { format } = useFormatAmount()
</script>

<template>
  <div
    :data-test="`cart-amount-row--total`"
    class="flex flex-row items-center justify-between text-2xl font-bold text-mcd-black"
  >
    <p>{{ t('shoppingCart.total') }}</p>
    <span class="block">{{ format(props.total ?? props.totalBlock.total ?? 0) }}</span>
  </div>
</template>
